import { offlineStore } from "./offline_store"
import { apiPost } from "../api_helper"
import { syncManager } from "./sync_manager"
import { networkStatus } from "./network_status"

export async function createTransactionOffline(data) {
  if (networkStatus.online) {
    try {
      return await apiPost("/api/transactions", { transaction: data })
    } catch (e) {
      // If network fails, queue it
    }
  }

  // Queue for later sync
  const op = await offlineStore.addOperation("create_transaction", data)
  syncManager.notify()
  return { id: `pending_${op.client_id}`, ...data, pending: true }
}

export async function createCategoryOffline(data) {
  if (networkStatus.online) {
    try {
      return await apiPost("/api/categories", { category: data })
    } catch (e) {
      // Queue on failure
    }
  }

  const op = await offlineStore.addOperation("create_category", data)
  syncManager.notify()
  return { id: `pending_${op.client_id}`, ...data, pending: true }
}

export async function createAccountOffline(data) {
  if (networkStatus.online) {
    try {
      return await apiPost("/api/accounts", { account: data })
    } catch (e) {
      // Queue on failure
    }
  }

  const op = await offlineStore.addOperation("create_account", data)
  syncManager.notify()
  return { id: `pending_${op.client_id}`, ...data, pending: true }
}
